import axios from "axios";
const config = {
	env: "local",
	// apiUrl: "http://localhost:5600/platform/v1",
	apiUrl: "https://sitepro-api.onap.uk/platform/v1",
	// apiUrl: "https://7cgqsbkf-5050.inc1.devtunnels.ms/admin",

};

const BASE_URL = config.apiUrl;

const client = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("platform_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const url: string = err.config?.url ?? "";
      // A 401 from /auth/login is just "wrong credentials" — the user is
      // still on the login screen, so there's no session to tear down.
      // Every OTHER 401 means the stored token is missing/expired/invalid,
      // which previously did nothing here: the request just silently
      // failed, the query/mutation rejected, and whichever page triggered
      // it was left showing stale or blank data with no indication why
      // (or, on first load, an infinite spinner). Force a logout + redirect
      // to the login screen on any of those instead, matching the fix
      // already applied to the company-admin panel's axios interceptor.
      if (!url.includes("auth/login")) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
    return Promise.reject(err.response?.data || err);
  }
);

export default client;
